import { ScrollArea, Stack } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";
import { StudentFeed } from "@features/student-announcements/components/StudentFeed";

export const Route = createFileRoute("/_layout/feed")({
    validateSearch: (search) => ({
        post: typeof search.post === "string" ? search.post : undefined,
    }),
    component: FeedPage,
    staticData: { crumb: { label: "Feed" } },
});

function FeedPage() {
    const { post } = Route.useSearch();

    return (
        <Stack
            w="100%" 
            h="100%" 
            mih={0}
            //pr={1}
            gap={0}
            style={{ flex: "1 1 0", minHeight: 0 }}
            bg="light-dark(var(--mantine-color-gray-2), var(--mantine-color-dark-8))"
        >
            <ScrollArea
                offsetScrollbars="y"
                style={{ flex: "1 1 0", minHeight: 0 }}
            >
                <StudentFeed highlighted={post} />
            </ScrollArea>
        </Stack>
    );
}
